import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const MobileSocialBlock = () => (
    <div className="social-media-section">
        <p>We're on social media</p>
        <div className="social-media-wrapper">
            <Button type="instagram" />
            <Button type="facebook" />
            <Button type="youtube" />
        </div>
    </div>
);

export default MobileSocialBlock;
